export default "__VITE_ASSET__d3899a1a__"